import _Vue, { PluginObject } from 'vue'

import VueAnalytics, { event as uaEvent } from 'vue-analytics'
import VueGtm, { useGtm } from '@gtm-support/vue2-gtm'
import router from '@/router'
import { OrbVizAnalytics, OrbVizAnalyticsOptions, EventNames, EventParams, CustomParams } from '@/plugins/analytics'

export const OrbVizAnalyticsPlugin: PluginObject<OrbVizAnalyticsOptions> = {
  install (Vue: typeof _Vue, options?: OrbVizAnalyticsOptions) {
    if (options) {
      Vue.use(VueAnalytics, {
        id: options?.uaID,
        router,
        debug: {
          sendHitTask: options.sendPageViews,
        },
        set: [
          { field: 'anonymizeIp', value: true },
        ],
      })

      Vue.use(VueGtm, {
        id: options.gtmOptions.id,
        queryParams: {
          gtm_auth: options.gtmOptions.environment.auth,
          gtm_preview: options.gtmOptions.environment.preview,
          gtm_cookies_win: 'x',
        },
        vueRouter: router,
      })
    }

    Vue.prototype.$analytics = {
      gtm: useGtm(),
      event (action: EventNames | string, eventParams: EventParams | CustomParams) {
        // Send legacy Google Universal (UA) analytics
        uaEvent({
          eventAction: action,
          eventCategory: eventParams.event_category,
          eventLabel: eventParams.event_label,
        })

        // // Send Google Tag Manager (GTM) analytics
        if (this.gtm) {
          this.gtm.trackEvent({
            event: action,
            ...eventParams,
          })
        }
      },
    } as OrbVizAnalytics
  },
}
